<template>
  <div class="chat_room_quotation_item">
    <div class="chat_table_box">
      <div class="chat_table_ttl">
        사전예약을 요청합니다.
      </div>
    </div>
    <div>
      <div>
        {{ bookingModel.telecomId }} {{ bookingModel.telecomType }} /
        {{ bookingModel.telecomUsed }}
      </div>
      <div>
        {{ bookingModel.telecomDevice }}
      </div>
      <div>{{ bookingModel.telecomColor }}</div>
      <div>
        {{ bookingModel.telecomUserName }}
      </div>
      <div>{{ bookingModel.telecomBirth }}</div>
      <div>{{ bookingModel.telecomPhone }}</div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
export default {
  props: {
    bookingModel: Object,
  },
  data() {
    return {};
  },
  mounted() {
    //alert(this.bookingModel);
  },
  methods: {},
};
</script>

<style></style>
